import includes from 'lodash/includes';
import mapValues from 'lodash/mapValues';
import some from 'lodash/some';
import toLower from 'lodash/toLower';
import isString from 'lodash/isString';
import { FALLBACK_MESSAGE } from '../const/message.const';
const FORBIDDEN_STRINGS = ['sql', '$', '#'];
/**
 * Util sanitizing an object or string with forbidden error details or characters
 * @param formattedError Record<string, unknown> | string
 * @param forbidden: Array of forbidden strings merged with default one
 * @returns Record<string, unknown> | string
 */
export const sanitizeError = (formattedError, forbidden = []) => {
    const forbiddenStrings = [...FORBIDDEN_STRINGS, ...forbidden];
    const verifyString = (value) => (some(forbiddenStrings, string => includes(toLower(value), string)))
        ? FALLBACK_MESSAGE.error
        : value;
    return isString(formattedError)
        ? verifyString(formattedError)
        : mapValues(formattedError, verifyString);
};
